export default __webpack_public_path__ + "static/media/bitcoin-btc-logo-01.119e43a4.svg";